module.exports = __webpack_public_path__ + "img/conflux_logo_only.79566af0.png";